// components/SEO.tsx
import Head from "next/head";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  url?: string;
}
import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  author = 'VGL Trans Express',
  locale = 'ro_RO'
}) => {
  useEffect(() => {
    // Title
    document.title = title;
    
    // Meta Description
    updateMetaTag('name', 'description', description);
    
    // Meta Keywords
    updateMetaTag('name', 'keywords', keywords);
    
    // Author
    updateMetaTag('name', 'author', author);
    
    // Robots
    updateMetaTag('name', 'robots', 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1');
    
    // Canonical URL
    updateLinkTag('rel', 'canonical', url);
    
    // Open Graph Tags
    updateMetaTag('property', 'og:title', title);
    updateMetaTag('property', 'og:description', description);
    updateMetaTag('property', 'og:image', image);
    updateMetaTag('property', 'og:url', url);
    updateMetaTag('property', 'og:type', type);
    updateMetaTag('property', 'og:locale', locale);
    updateMetaTag('property', 'og:site_name', 'VGL Trans Express');
    
    // Twitter Cards
    updateMetaTag('name', 'twitter:card', 'summary_large_image');
    updateMetaTag('name', 'twitter:title', title);
    updateMetaTag('name', 'twitter:description', description);
    updateMetaTag('name', 'twitter:image', image);
    updateMetaTag('name', 'twitter:url', url);
    
    // Additional SEO tags
    updateMetaTag('name', 'theme-color', '#1e293b');
    updateMetaTag('name', 'msapplication-TileColor', '#1e293b');
    
    // Language
    document.documentElement.lang = 'ro';
    
    // Viewport (dacă nu e deja setat)
    updateMetaTag('name', 'viewport', 'width=device-width, initial-scale=1.0');
    
    // Schema.org JSON-LD pentru business local
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "TransportationCompany",
      "name": "VGL Trans Express",
      "description": description,
      "url": url,
      "logo": image,
      "telephone": "+40745586183",
      "email": "contact@vgltransexpress.com",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "RO",
        "addressRegion": "Cluj",
        "addressLocality": "Cluj-Napoca"
      },
      "serviceArea": {
        "@type": "Country",
        "name": "România"
      },
      "services": [
        "Transport mărfuri",
        "Logistică",
        "Depozitare",
        "Livrare rapidă"
      ],
      "openingHours": "Mo-Fr 08:00-18:00",
      "sameAs": [
        "https://www.facebook.com/vgltransexpress",
        "https://wa.me/+40745586183"
      ]
    };
    
    // Adaugă sau actualizează JSON-LD script
    updateJSONLD(schemaData);
    
  }, [title, description, keywords, image, url, type, author, locale]);
  
  const updateMetaTag = (attribute, value, content) => {
    let element = document.querySelector(`meta[${attribute}="${value}"]`);
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, value);
      document.head.appendChild(element);
    }
    element.setAttribute('content', content);
  };
  
  const updateLinkTag = (attribute, value, href) => {
    let element = document.querySelector(`link[${attribute}="${value}"]`);
    if (!element) {
      element = document.createElement('link');
      element.setAttribute(attribute, value);
      document.head.appendChild(element);
    }
    element.setAttribute('href', href);
  };
  
  const updateJSONLD = (data) => {
    const scriptId = 'jsonld-schema';
    let script = document.getElementById(scriptId);
    
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    
    script.textContent = JSON.stringify(data);
  };
  
  return null; // Component-ul nu renderează nimic vizibil
};


export default SEO;
